import { useWindowDimensions } from 'react-native'

export const minWidth: Record<TBreakpoint, number> = {
  xs: 0,
  sm: 540,
  xm: 640,
  md: 820,
  lg: 1060,
  xl: 1200,
}

export const useDimensions = () => {
  const { width, height } = useWindowDimensions()

  return {
    width,
    height,
    xs: width < minWidth.sm,
    sm: width < minWidth.xm && width >= minWidth.sm,
    xm: width < minWidth.md && width >= minWidth.xm,
    md: width < minWidth.lg && width >= minWidth.md,
    lg: width < minWidth.xl && width >= minWidth.lg,
    xl: width > minWidth.xl,
    lessThan: {
      xs: width < minWidth.xs,
      sm: width < minWidth.sm,
      xm: width < minWidth.xm,
      md: width < minWidth.md,
      lg: width < minWidth.lg,
      xl: width < minWidth.xl,
    },
  }
}
